

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import { getByLabelText } from "@testing-library/react";
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StatusDetails = ({
    status, setStatus
}) => {

    const { user: currentUser } = useSelector((state) => state.auth);

    const getLabel = () => {
        switch (status) {
            case 0:
                return ["Draft", "darkgrey"]
            case 1:
                return ["Pending approval", "#F5A10F"]
            case 2:
                return ["Approved", "#2E7D32"]
            case 3:
                return ["Canceled", "grey"]
            case 4:
                return ["Invalid", "crimson"]
            case 5:
                return ["Paid", "#1E90FF"]
            case 6:
                return ["Partially Paid", "#aacef0"]
        }
    }



    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (newStatus) => {
        if (newStatus != null) {
            setStatus(newStatus)
        }

        setAnchorEl(null);
    };

    return (
        <>
            <Button variant='contained' onClick={handleClick} sx={{ width: "100%", color:'#FFFFFF', backgroundColor:getLabel()[1]}}
                endIcon={<KeyboardArrowDownIcon />}>
                {getLabel()[0]}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => { handleClose(null) }}>

                {status == 0 || status == 3 || status == 4 ?

                    <MenuItem  onClick={() => { handleClose(1) }}>
                        <ListItemIcon>
                            <SendIcon fontSize="small" />
                        </ListItemIcon>
                        Send to Administrator Approval
                    </MenuItem> : <></>}

                {currentUser && currentUser.type == 1 ? <>

                    {status == 1 ?
                        <>
                            <MenuItem onClick={() => { handleClose(3) }}>Cancel</MenuItem>
                            <MenuItem onClick={() => { handleClose(2) }}>Approve</MenuItem>
                            <MenuItem onClick={() => { handleClose(4) }}>Reject</MenuItem></>
                        : <></>
                    }

                    {status == 2 ? <>
                        <MenuItem onClick={() => { handleClose(5) }}>Set as paid</MenuItem>
                        <MenuItem onClick={() => { handleClose(6) }}>Set as partially paid</MenuItem>
                        <MenuItem onClick={() => { handleClose(3) }}>Cancel</MenuItem>
                        <MenuItem onClick={() => { handleClose(4) }}>Reject</MenuItem></>
                        : <></>
                    }

                    {status == 5 ? <>
                        <MenuItem onClick={() => { handleClose(2) }}>Cancel Payment (Set as approved)</MenuItem></>
                        : <></>
                    }

                    {status == 6 ? <>
                        <MenuItem onClick={() => { handleClose(5) }}>Set as paid</MenuItem>
                        <MenuItem onClick={() => { handleClose(2) }}>Cancel Payment (Set as approved)</MenuItem></>
                        : <></>
                    }

                </> : <></>}



            </Menu>

        </>
    )
}

export default StatusDetails